import { render, staticRenderFns } from "./ImageCom.vue?vue&type=template&id=1e0a0e2c&scoped=true&"
import script from "./ImageCom.vue?vue&type=script&lang=js&"
export * from "./ImageCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0a0e2c",
  null
  
)

export default component.exports